import { useMutation } from 'react-query';
import { AxiosError } from 'axios';
import api from 'services';
import { ConfirmPayload, ConfirmResponse } from 'services/requests';
import { ACCOUNT_BLOCKED_API_ERRORS, ApiError } from 'services/api.errors';
import { useNavigate } from 'hooks/routes';
import { protectApiError } from 'utils/typeGuards';
import { MutationKeys } from 'constants/mutationKeys';

export const useConfirmation = () => {
  const { toLoginBlocked } = useNavigate();

  const mutate = async (payload: ConfirmPayload) => {
    const { data } = await api.confirm(payload);

    return data;
  };

  const mutationKey = MutationKeys.confirmation;

  return useMutation<ConfirmResponse, AxiosError<ApiError>, ConfirmPayload>(
    mutationKey,
    mutate,
    {
      onSuccess: ({ tokenData }) => {
        api.setTokens(tokenData?.accessToken, tokenData?.refreshToken);
      },
      onError(error) {
        if (protectApiError(error) && error.response?.data.code) {
          if (ACCOUNT_BLOCKED_API_ERRORS.includes(error.response.data.code)) {
            toLoginBlocked(error.response?.data);
          }
        }
      },
    },
  );
};
